import Glide from '@glidejs/glide';
import {
    LoadingClass,
    preventVerticalScroll,
    ArrowDisabler,
} from './glideVisible';

export default function initiateSlider() {
    const sliders = document.querySelectorAll('.glide');
    Object.values(sliders).map((slider) => {
        const track = slider.querySelector('.glide__slides');
        const gap = 15;
        const settings = {
            type: 'slider',
            startAt: 0,

            perView: track.dataset.slidesPerView,
            perTouch: 1,
            bound: true,
            hoverpause: track.dataset.slidesHoverPause,
            animationDuration: track.dataset.slidesDuration,
            rewind: false,
            gap,
            breakpoints: {
                5000: {
                    perView: 4,
                },
                1440: {
                    perView: 4,
                },
                1360: {
                    perView: 3,
                },
                1280: {
                    perView: 3,
                },
                1266: {
                    perView: 3,
                },
                1024: {
                    perView: 3,
                },
                768: {
                    perView: 3,
                },
                575: {
                    perView: 2,
                },
                412: {
                    perView: 2,
                },
                375: {
                    perView: 2,
                },
            },
        };

        const mountSettings = {
            LoadingClass,
            preventVerticalScroll,
            ArrowDisabler,
        };
        const glide = new Glide(slider, settings);

        // Progress bar
        const slidesLimit = 8; // this is set in the asset listing (assets per page)
        const screenWidth = window.innerWidth;
        let screenWidthOffset;
        switch (true) {
            case screenWidth < 768:
                screenWidthOffset = 2;
                break;
            case screenWidth < 1360:
                screenWidthOffset = 3;
                break;
            case screenWidth < 5000:
                screenWidthOffset = 4;
                break;

            default:
                screenWidthOffset = 2;
                break;
        }

        const effectiveSlides = slidesLimit - screenWidthOffset;

        const progressBar = document.querySelector(
            '.news-media-carousel__progress-bar'
        );

        glide.on(['mount.after', 'run'], () => {
            const currentIndex = glide.index;
            const width = !currentIndex
                ? 0
                : `calc(100% * ${Math.abs(currentIndex / effectiveSlides)})`;
            if (progressBar) {
                progressBar.style.width = width;
            }
        });
        // END Progress bar

        return glide.mount(mountSettings);
    });
}

window.addEventListener('DOMContentLoaded', initiateSlider);

export function preventButtonsOnFewSlides() {
    const resourceSliderCarousels = document.querySelectorAll(
        '.news-media-carousel-js'
    );

    const mediaQuery = window.matchMedia('(max-width: 1349px)');

    resourceSliderCarousels.forEach((resourceSlider) => {
        const sliderTiles = resourceSlider.querySelectorAll(
            '.news-media__container-js'
        );

        const sliderArrowControls =
            resourceSlider.querySelectorAll('.glide__arrow');

        const controlArrowsMediaQuery = () => {
            for (let j = 0; j < sliderTiles.length; j++) {
                sliderArrowControls.forEach((glideArrowControl) => {
                    if (j < 4) {
                        if (mediaQuery.matches) {
                            glideArrowControl.classList.remove(
                                'hide--controls'
                            );
                        } else {
                            glideArrowControl.classList.add('hide--controls');
                        }
                    } else {
                        glideArrowControl.classList.remove('hide--controls');
                    }
                });
            }
        };

        controlArrowsMediaQuery();

        window.addEventListener('resize', () => {
            controlArrowsMediaQuery();
        });
    });
}

window.addEventListener('DOMContentLoaded', preventButtonsOnFewSlides);
